/**
 * Legacy module — kept for backwards compatibility.
 *
 * All image / asset URL building is now centralized in `assetUrl.js`, which
 * correctly uses `window.location.origin` in production (so logos no longer
 * break after deploys when REACT_APP_BACKEND_URL is stale in the bundled JS).
 *
 * Do NOT add new logic here. Import from `../lib/assetUrl` in new code.
 */

import { getAssetUrl, getApiBase } from './assetUrl';

export const getApiBaseUrl = getApiBase;
export const getImageUrl = getAssetUrl;
export const getLogoUrl = getAssetUrl;
export const getAvatarUrl = getAssetUrl;
